const config = {
    safariHelpUrl: 'https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac',
    chromeHelpUrl: 'https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en'
}

export default config;